import { useNavigate } from "react-router-dom";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button } from "@mui/material";

const MySubscription = () => {
  const navigate = useNavigate();

  const subscriptions = [
    {
      id: 1,
      planName: "Premium",
      nextPayment: "Dec 25, 2026",
      amount: "$629.37",
      billingCycle: "Annually",
      cardLast4: "4582",
      canChange: true,
      features: [
        "Unlimited access to all premium tools",
        "Priority customer support",
        "Advanced analytics & reporting",
        "Access to new features first",
        "Higher usage limits",
        "Dedicated account manager",
      ],
    },
  ];

  return (
    <div className="subscription_page">

      {/* Header */}
      <div className="main_title">
        <h1>My Subscription</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - My Subscription
        </p>
      </div>
      <div className="cards ai_token_card">
      <div className="card">
        <div className="alert">
          <p className="alert-text">AI limit reached for your plan</p>
        </div>
        <p className="description">You have reached the monthly AI query limit for vendors on the Pro plan.</p>
        <div className="usage-info">
          <p className="usage-status">0 / 150 queries this month</p>
          <div className="progress-bar">
            <div className="progress"></div>
          </div>
        </div>
        <div className="actions">
          <Button className="btn btn_primary">Upgrade Plan</Button>
          <Button variant="outlined" className="btn">View Plans</Button>
        </div>
      </div>
      <div className="subscriptions_container">

        {/* Subscription Card */}
        {subscriptions.map((sub) => (
          <div key={sub.id} className="sub_card">

            {/* Top row */}
            <div className="sub_top_row">
              <div>
                <h2 className="plan_name">{sub.planName}</h2>
                <span className="badge_active">Active</span>
              </div>

              <div className="card_info">
                <CreditCardIcon style={{ fontSize: 32 }} />
                <span className="card_digits">•••• {sub.cardLast4}</span>
              </div>
            </div>

            {/* Payment details */}
            <div className="sub_details">
              <p><strong>Billing:</strong> {sub.billingCycle}</p>
              <p>
                <strong>Next Payment:</strong> {sub.amount} on {sub.nextPayment}
              </p>
            </div>

            {/* Feature List */}
            <div className="features_section">
              <h3 className="features_title">What's included in your plan</h3>
              <ul className="feature_list">
                {sub.features.map((feature, index) => (
                  <li key={index}>
                    <CheckCircleIcon className="check_icon" />
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            {/* Buttons */}
            <div className="actions">
              <button className="btn_outline" onClick={() => navigate("/subscription")}>
                Upgrade Plan
              </button>
              <button className="btn_cancel">Cancel Subscription</button>
            </div>

          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default MySubscription;
